import classNames from 'classnames';
import { ReactNode } from 'react';
import styled from 'styled-components';

const Root = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  padding: 0 var(--triple-unit);
  isolation: isolate;
`;
const AbsolutelyPositionedSvg = styled.svg`
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
  height: 80%;
  width: 100%;
  padding: inherit;

  &.extraInfo {
    bottom: 15%;
    height: 70%;
  }
`;

const ThreeColumsGrid = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: repeat(3, 1fr);
  column-gap: var(--triple-unit);
  row-gap: var(--double-unit);
  z-index: 1;

  & > *:nth-child(-n + 2) {
    transform: translateX(calc(50% + var(--intermediate-unit)));
  }

  & > *:nth-child(n + 3) {
    grid-row: 2;
  }
`;

type FieldProps = { className?: string };
const Field = ({ className }: FieldProps) => {
  return (
    <AbsolutelyPositionedSvg
      viewBox="0 0 99 101"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.8605 3.59322C15.1684 1.64995 16.8438 0.219116 18.8113 0.219116H80.2939C82.2615 0.219116 83.9368 1.64995 84.2447 3.59322L98.8198 95.5932C99.2045 98.0217 97.3278 100.219 94.869 100.219H4.2362C1.77743 100.219 -0.0992627 98.0217 0.285468 95.5932L14.8605 3.59322Z"
        fill="#8AC26F"
        fillOpacity="0.16"
      />
    </AbsolutelyPositionedSvg>
  );
};

type Props = { children: ReactNode; extraInfo?: boolean };

export const FootballLineup = ({ children, extraInfo }: Props) => {
  return (
    <Root>
      <Field className={classNames({ extraInfo })} />
      <ThreeColumsGrid>{children}</ThreeColumsGrid>
    </Root>
  );
};
